import { createAction, createReducer } from "@reduxjs/toolkit";

export const setMenuListAction = createAction("menu/setMenuList");
export const updateMenuList = createAction("menu/setUpdateMenuList");
export const setPermissionListAction = createAction(
  "menu/setPermissionListAction"
);

export const menuReducer = createReducer(
  {
    menuList: [],
    loading: false,
    error: null,
  },
  {
    [setMenuListAction]: (state, action) =>
      (state = { ...state, menuList: action.payload }),
    [setPermissionListAction]: (state, action) =>
      (state = { ...state, permissionList: action.payload }),
    [updateMenuList]: (state, action) =>
      (state = {
        ...state,
        menuList: state.menuList.map((menu, index) =>
          action.payload.index === index
            ? { ...menu, subMenuOpen: action.payload.status }
            : { ...menu, subMenuOpen: false }
        ),
      }),
  }
);
